//基础元数据信息
import request from '@/utils/request'

// 查询国家货币列表
export function currencyList(data) {
  return request({
    url: '/sys/currency/list',
    method: 'get',
    params: data
  })
}

//货币汇率
export function currencyPageList(data) {
  return request({
    url: '/sys/currency/pageList',
    method: 'post',
    data: data
  })
}
export function currencyDetail(data) {
  return request({
    url: '/sys/currency/detail',
    method: 'get',
    params: data
  })
}
export function submitCurrency(data) {
  return request({
    url: '/sys/currency/submit',
    method: 'post',
    data: data
  })
}
export function changeCurrencyStatus(data) {
  return request({
    url: '/sys/currency/changeStatus',
    method: 'post',
    data: data
  })
}
export function syncCurrencyRate(data) {
  return request({
    url: '/sys/currency/syncCurrencyRate',
    method: 'post',
    data: data
  })
}
export function editCurrencyRate(data) {
  return request({
    url: '/sys/currency/editCurrencyRate',
    method: 'post',
    data: data
  })
}

//批量修改汇率

export function batchCurrencyUpdate(data) {
  return request({
    url: '/sys/currency/batchCurrencyUpdate',
    method: 'post',
    data: data
  })
}











